import { SortType } from "./../utils/Constants";

const aframeMixedSortTypes = [SortType.AFRAMEMIXEDSINGLE, SortType.AFRAMEMIXEDNORMAL];

export const isAFrameMixed = (sortType: number): boolean => {
  return aframeMixedSortTypes.includes(sortType);
};
